// import React, { useEffect, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import { toast } from "react-toastify";
// import {
//   addMatchQuestion,
//   getMatchQuestions,
//   updateDeleteMatchQuestion,
// } from "../../services/matchQuestionService";
// import { getMatches } from "../../services/matchService";
// import { getSectionQuestions } from "../../services/sectionQuestionsService";

// export const AddAsectionsLayer = () => {
//   const navigate = useNavigate();
//   const { id } = useParams();

//   const [matches, setMatches] = useState([]);
//   const [sectionAQuestions, setSectionAQuestions] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const [form, setForm] = useState({
//     match_id: "",
//     league_id: "",
//     question_title: "",
//     options: ["", ""],
//     status: "active",
//   });

//   /* LOAD MATCHES + SECTION A QUESTIONS */
//   useEffect(() => {
//     loadMatches();
//     loadSectionAQuestions();
//   }, []);

//   const loadMatches = async () => {
//     try {
//       const res = await getMatches();
//       if (res?.status === true) {
//         setMatches(res.data || []);
//       }
//     } catch {
//       toast.error("Failed to load matches");
//     }
//   };

//   const loadSectionAQuestions = async () => {
//     try {
//       const res = await getSectionQuestions("A");
//       if (res?.status) {
//         setSectionAQuestions(res.data || []);
//       }
//     } catch {
//       toast.error("Failed to load Section A questions");
//     }
//   };

//   /* EDIT MODE */
//   useEffect(() => {
//     if (!id || matches.length === 0) return;

//     const fetchQuestion = async () => {
//       try {
//         for (let m of matches) {
//           const res = await getMatchQuestions(m.id);

//           const question = res?.data?.data?.find(
//             (q) => String(q.id) === String(id)
//           );

//           if (question) {
//             setForm({
//               match_id: String(question.match_id),
//               league_id: question.league_id,
//               question_title: question.question_title,
//               options: Array.isArray(question.options)
//                 ? question.options
//                 : JSON.parse(question.options || "[]"),
//               status: question.status,
//             });
//             break;
//           }
//         }
//       } catch {
//         toast.error("Failed to load question");
//       }
//     };

//     fetchQuestion();
//   }, [id, matches]);

//   /* MATCH CHANGE */
//   const handleMatchChange = (e) => {
//     const selectedMatchId = e.target.value;

//     const selectedMatch = matches.find(
//       (m) => String(m.id) === String(selectedMatchId)
//     );

//     if (!selectedMatch) return;

//     setForm({
//       ...form,
//       match_id: selectedMatchId,
//       league_id: selectedMatch.league_id || "",
//       options: [
//         selectedMatch.team_a || "",
//         selectedMatch.team_b || "",
//       ],
//     });
//   };

//   const handleChange = (e) =>
//     setForm({ ...form, [e.target.name]: e.target.value });

//   /* SUBMIT */
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!form.match_id)
//       return toast.error("Please select match");

//     if (!form.question_title)
//       return toast.error("Please select question");

//     setLoading(true);

//     try {
//       const payload = {
//         ...form,
//         options: form.options,
//       };

//       const res = id
//         ? await updateDeleteMatchQuestion({
//             action: "update",
//             id,
//             ...payload,
//           })
//         : await addMatchQuestion(payload);

//       if (res?.data?.status) {
//         toast.success(res.data.msg || "Saved Successfully");
//         navigate("/asections-list");
//       } else {
//         toast.error(res?.data?.msg || "Operation Failed");
//       }
//     } catch (error) {
//       toast.error(
//         error?.response?.data?.msg ||
//           error?.response?.data?.message ||
//           "Server Error"
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="container mt-4">
//       <div className="card shadow-sm">
//         <div className="card-body">
//           <h4 className="mb-4">
//             {id ? "Update Section A Question" : "Add Section A Question"}
//           </h4>

//           <form onSubmit={handleSubmit} className="row g-3">

//             {/* MATCH */}
//             <div className="col-md-6">
//               <label>Select Match</label>
//               <select
//                 className="form-control"
//                 value={form.match_id}
//                 onChange={handleMatchChange}
//               >
//                 <option value="">-- Select Match --</option>
//                 {matches.map((m) => (
//                   <option key={m.id} value={String(m.id)}>
//                     {m.team_a} vs {m.team_b}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             {/* STATUS */}
//             <div className="col-md-6">
//               <label>Status</label>
//               <select
//                 name="status"
//                 className="form-control"
//                 value={form.status}
//                 onChange={handleChange}
//               >
//                 <option value="active">Active</option>
//                 <option value="closed">Closed</option>
//               </select>
//             </div>

//             {/* SECTION A DROPDOWN */}
//             <div className="col-12">
//               <label>Select Section A Question</label>
//               <select
//                 name="question_title"
//                 className="form-control"
//                 value={form.question_title}
//                 onChange={handleChange}
//               >
//                 <option value="">-- Select Question --</option>
//                 {sectionAQuestions.map((q) => (
//                   <option key={q.id} value={q.question}>
//                     {q.question}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             {/* OPTIONS AUTO FROM TEAMS */}
//             <div className="col-12">
//               <label>Options (Auto From Teams)</label>

//               <div className="mb-2">
//                 <input
//                   type="text"
//                   className="form-control"
//                   value={form.options[0] || ""}
//                   readOnly
//                 />
//               </div>

//               <div className="mb-2">
//                 <input
//                   type="text"
//                   className="form-control"
//                   value={form.options[1] || ""}
//                   readOnly
//                 />
//               </div>
//             </div>

//             <div className="col-12">
//               <button className="btn btn-primary w-100" disabled={loading}>
//                 {loading
//                   ? "Please wait..."
//                   : id
//                   ? "Update Question"
//                   : "Add Question"}
//               </button>
//             </div>

//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };


import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  addMatchQuestion,
  getMatchQuestions,
  updateDeleteMatchQuestion,
} from "../../services/matchQuestionService";
import { getMatches } from "../../services/matchService";
import { getSectionQuestions } from "../../services/sectionQuestionsService";

export const AddAsectionsLayer = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [matches, setMatches] = useState([]);
  const [sectionAQuestions, setSectionAQuestions] = useState([]);
  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    match_id: "",
    league_id: "",
    question_title: "",
    options: ["", ""],
    status: "active",
  });

  /* LOAD MATCHES + SECTION A QUESTIONS */
  useEffect(() => {
    loadMatches();
    loadSectionAQuestions();
  }, []);

  const loadMatches = async () => {
    try {
      const res = await getMatches();
      if (res?.status === true) {
        setMatches(res.data || []);
      }
    } catch {
      toast.error("Failed to load matches");
    }
  };

  const loadSectionAQuestions = async () => {
    try {
      const res = await getSectionQuestions("A");
      if (res?.status) {
        setSectionAQuestions(res.data || []);
      }
    } catch {
      toast.error("Failed to load Section A questions");
    }
  };

  /* EDIT MODE */
  useEffect(() => {
    if (!id || matches.length === 0) return;

    const fetchQuestion = async () => {
      try {
        for (let m of matches) {
          const res = await getMatchQuestions(m.id);

          const question = res?.data?.data?.find(
            (q) => String(q.id) === String(id)
          );

          if (question) {
            setForm({
              match_id: String(question.match_id),
              league_id: question.league_id,
              question_title: question.question_title,
              options: Array.isArray(question.options)
                ? question.options
                : JSON.parse(question.options || "[]"),
              status: question.status,
            });
            break;
          }
        }
      } catch {
        toast.error("Failed to load question");
      }
    };

    fetchQuestion();
  }, [id, matches]);

  /* MATCH CHANGE */
  const handleMatchChange = (e) => {
    const selectedMatchId = e.target.value;

    const selectedMatch = matches.find(
      (m) => String(m.id) === String(selectedMatchId)
    );

    if (!selectedMatch) return;

    setForm({
      ...form,
      match_id: selectedMatchId,
      league_id: selectedMatch.league_id || "",
      options: [
        selectedMatch.team_a || "",
        selectedMatch.team_b || "",
      ],
    });
  };

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  /* SUBMIT */
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.match_id)
      return toast.error("Please select match");

    if (!form.question_title)
      return toast.error("Please select question");

    setLoading(true);

    try {
      const payload = {
        ...form,
        options: form.options,
      };

      const res = id
        ? await updateDeleteMatchQuestion({
            action: "update",
            id,
            ...payload,
          })
        : await addMatchQuestion(payload);

      if (res?.data?.status) {
        toast.success(res.data.msg || "Saved Successfully");
        navigate("/asections-list");
      } else {
        toast.error(res?.data?.msg || "Operation Failed");
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.msg ||
          error?.response?.data?.message ||
          "Server Error"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-4">
      <div className="card shadow-sm">
        <div className="card-body">
          <h4 className="mb-4">
            {id ? "Update Section A Question" : "Add Section A Question"}
          </h4>

          <form onSubmit={handleSubmit} className="row g-3">

            {/* MATCH */}
            <div className="col-md-6">
              <label>Select Match</label>
              <select
                className="form-control"
                value={form.match_id}
                onChange={handleMatchChange}
              >
                <option value="">-- Select Match --</option>
                {matches.map((m) => (
                  <option key={m.id} value={String(m.id)}>
                    {m.team_a} vs {m.team_b}
                  </option>
                ))}
              </select>
            </div>

            {/* STATUS */}
            <div className="col-md-6">
              <label>Status</label>
              <select
                name="status"
                className="form-control"
                value={form.status}
                onChange={handleChange}
              >
                <option value="active">Active</option>
                <option value="closed">Closed</option>
              </select>
            </div>

            {/* SECTION A DROPDOWN */}
            <div className="col-12">
              <label>Select Section A Question</label>
              <select
                name="question_title"
                className="form-control"
                value={form.question_title}
                onChange={handleChange}
              >
                <option value="">-- Select Question --</option>
                {sectionAQuestions.map((q) => (
                  <option key={q.id} value={q.question}>
                    {q.question}
                  </option>
                ))}
              </select>
            </div>

            {/* OPTIONS AUTO FROM TEAMS */}
            <div className="col-12">
              <label>Options (Auto From Teams)</label>

              <div className="mb-2">
                <input
                  type="text"
                  className="form-control"
                  value={form.options[0] || ""}
                  readOnly
                />
              </div>

              <div className="mb-2">
                <input
                  type="text"
                  className="form-control"
                  value={form.options[1] || ""}
                  readOnly
                />
              </div>
            </div>

            <div className="col-12">
              <button className="btn btn-primary w-100" disabled={loading}>
                {loading
                  ? "Please wait..."
                  : id
                  ? "Update Question"
                  : "Add Question"}
              </button>
            </div>

          </form>
        </div>
      </div>
    </div>
  );
};